import { findTextMatches } from '../../../engine/core/text-search.js';

const blocks = new Set(['P', 'DIV', 'LI', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'BLOCKQUOTE', 'PRE', 'TR']);

/** Search visible prose, keeping inline formatting transparent and blocks apart. */
export function textContentIndex(root) {
  let text = '';
  const segments = [];
  function visit(node) {
    if (node.nodeType === 3) {
      segments.push({ node, start: text.length, end: text.length + node.textContent.length });
      text += node.textContent;
    } else {
      if (node.nodeType === 1 && node.matches('script, style, button, .katex-mathml, [aria-hidden="true"]')) return;
      if (node.nodeName === 'BR') text += '\n';
      for (const child of node.childNodes) visit(child);
      if (blocks.has(node.nodeName) && !text.endsWith('\n')) text += '\n';
    }
  }
  visit(root);
  return { text, segments };
}

export function textFromHtml(html) {
  const template = document.createElement('template');
  template.innerHTML = html || '';
  return textContentIndex(template.content).text;
}

/** CSS highlights never insert markup into collaborative editor content. */
export function highlightSearchContent(root, query, activeIndex, name) {
  clearSearchHighlights(name);
  if (!root || !query) return;
  const { text, segments } = textContentIndex(root);
  let firstIndex = 0, lastIndex = 0;
  const ranges = findTextMatches(text, query).map(match => {
    while (segments[firstIndex]?.end <= match.start) firstIndex++;
    lastIndex = Math.max(firstIndex, lastIndex);
    while (segments[lastIndex]?.end < match.end) lastIndex++;
    const first = segments[firstIndex], last = segments[lastIndex];
    if (!first || !last) return null;
    const range = document.createRange();
    range.setStart(first.node, match.start - first.start);
    range.setEnd(last.node, match.end - last.start);
    return range;
  }).filter(Boolean);
  if (globalThis.CSS?.highlights && globalThis.Highlight) {
    const highlights = new Highlight();
    for (const range of ranges) highlights.add(range);
    CSS.highlights.set(name, highlights);
    if (ranges[activeIndex]) CSS.highlights.set(`${name}-current`, new Highlight(ranges[activeIndex]));
  }
  return ranges[activeIndex] || null;
}

export function clearSearchHighlights(name) {
  globalThis.CSS?.highlights?.delete(name);
  globalThis.CSS?.highlights?.delete(`${name}-current`);
}

export function revealSearchRange(range, scroller) {
  if (!range || !scroller) return;
  const match = range.getBoundingClientRect();
  const bounds = scroller.getBoundingClientRect();
  if (match.top < bounds.top + 12 || match.bottom > bounds.bottom - 12) {
    scroller.scrollTop += match.top + match.height / 2 - bounds.top - bounds.height / 2;
  }
}
